import { systemWidgetType } from '../landingPageConstants';

export default [
    {
        refreshRateMilliseconds: 0,
        landingPageWidget: {
            type: systemWidgetType,
            configurationKey: 'systemLinks',
            panelTitleOverride: 'systems',
        },
    },
    {
        refreshRateMilliseconds: 0,
        landingPageWidget: {
            type: systemWidgetType,
            configurationKey: 'userFavorites',
            panelTitleOverride: 'userFavorites',
        },
    },
];
